import { StringRequired } from '../primitive/string';

export const Surname = StringRequired.annotate({
  message: 'Vyplňte příjmení!',
});
